import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

const TableData = ({
  showIndex,
  columns,
  data,
  paginator,
  startRow,
  onSort,
  rowClick,
  rowSelector,
  checkbox,
  hideCheckbox = null,
  onChecked,
  disabledCheckbox,
}) => {
  const darkMode = useSelector((state) => state.theme.darkMode);
  const [height, setHeight] = useState(500);

  const [rowSelect, setRowSelect] = useState(0);
  const selector = rowSelector ? rowSelector : "id";

  const [dtlState, setState] = useState({
    checkAll: [],
    checked: [],
  });
  const { checkAll, checked } = dtlState;

  useEffect(() => {
    const rowHeight = 150; // Height of one row in pixels
    const headerHeight = 150; // Height of the table header in pixels
    const maxTableHeight = 50000;
    const padding = 20;
    let tableHeight = Math.min(
      data.length * rowHeight + headerHeight + padding,
      maxTableHeight
    );
    setHeight(tableHeight);
  }, [data]);

  const onRowClick = (item) => {
    onChecked([]);
    setRowSelect(item[selector]);
    rowClick(item);
  };

  const onSingleCheck = (value, item = null, selected = null) => {
    const _checkAll = [...checkAll];
    const _checked = [...checked];
    const index = _checked.findIndex((e) => e == value);
    if (selected && hideCheckbox != null) {
      if (hideCheckbox(item)) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "You cannot select this item for Web/SAP Sync because it's not approved yet!",
        });
        return;
      }
    }
    if (checkbox && _checked && onChecked && _checkAll.length > 0) {
      if (index > -1) {
        _checked.splice(index, 1);
        _checkAll.splice(index, 1);
      } else {
        _checked.push(value);
        _checkAll.push(value);
      }
      onChecked(_checked);
      setRowSelect(0);
    } else if (checkbox && _checked && onChecked && _checkAll.length < 1) {
      // checked.length > 0 ? onChecked([]) : onChecked([value]);
      if (index > -1) {
        _checked.splice(index, 1);
      } else {
        _checked.push(value);
      }
      onChecked(_checked);
      setRowSelect(0);
    }
    setState({ ...dtlState, checkAll: _checkAll, checked: _checked });
  };

  const onCheckAll = (e) => {
    const _checkAll = [...checkAll];
    const _checked = [...checked];
    if (checkbox && checked && onChecked && _checkAll.length < 1) {
      if (e.target.checked) {
        data.map((item, i) => {
          if (!disabledCheckbox || !item[disabledCheckbox]) {
            _checked.push(item[checkbox]);
            _checkAll.push(item[checkbox]);
          }
        });
        onChecked(_checked);
        setRowSelect(0);
      } else {
        _checkAll.splice(0, _checkAll.length);
        _checked.splice(0, _checked.length);
        onChecked([]);
        setRowSelect(0);
      }
    } else {
      _checkAll.splice(0, _checkAll.length);
      _checked.splice(0, _checked.length);
      onChecked([]);
      setRowSelect(0);
    }
    setState({ ...dtlState, checkAll: _checkAll, checked: _checked });
  };

  useEffect(() => {
    onChecked && onChecked([]);
  }, [data]);

  return (
    <div className="row tbl-container">
      <div
        className="col-lg-12 col-md-12 col-12 tbl-fixed"
        style={{
          maxHeight: `${height}px`,
          overflowY: "hidden",
        }}
      >
        <table
          className={`table ${
            darkMode ? "m-table-dark" : "m-table"
          } table-condensed`}
          style={{
            marginTop: 16,
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: 0,
          }}
        >
          <thead>
            <tr>
              {showIndex && (
                <th
                  style={{
                    width: 50,
                    backgroundColor: "	#eeeeee",
                    borderTopLeftRadius: "16px",
                    verticalAlign: "middle",
                    color: "#757575",
                    fontWeight: "600",
                  }}
                >
                  No
                </th>
              )}
              {checkbox && (
                <th
                  style={{
                    width: 20,
                    backgroundColor: "	#eeeeee",
                    verticalAlign: "middle",
                    color: "#757575",
                    fontWeight: "600",
                  }}
                >
                  {
                    // checkAll
                    //   ?
                    <input
                      type="checkbox"
                      checked={checked.length > 0 && checkAll.length > 0}
                      disabled={checked.length > 0 && checkAll.length == 0}
                      onChange={onCheckAll}
                    />
                    // : <input type="checkbox" disabled={!checkAll} />
                  }
                </th>
              )}
              {columns.map((item, i) => {
                return item.sortable ? (
                  <th
                    key={"key-" + i}
                    style={
                      i == columns.length - 1
                        ? {
                            backgroundColor: "	#eeeeee",
                            fontWeight: "600",
                            borderTopRightRadius: "16px",
                            color: "#757575",
                            ...item.style,
                          }
                        : {
                            backgroundColor: "	#eeeeee",
                            fontWeight: "600",
                            color: "#757575",
                            ...item.style,
                          }
                    }
                  >
                    <div
                      className="d-flex"
                      style={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: "4px 0",
                      }}
                      onClick={onSort(item.field)}
                    >
                      <span className="d-block mr-2 flex-1">{item.title}</span>
                      {paginator.orders.split(":")[0] == item.field && (
                        <i
                          className={
                            paginator.direction == "asc"
                              ? "fa fa-arrow-down"
                              : "fa fa-arrow-up"
                          }
                        />
                      )}
                    </div>
                  </th>
                ) : (
                  <th
                    key={"key-" + i}
                    style={
                      i == columns.length - 1
                        ? {
                            backgroundColor: "	#eeeeee",
                            fontWeight: "600",
                            borderTopRightRadius: "16px",
                            color: "#757575",
                            ...item.style,
                          }
                        : {
                            backgroundColor: "	#eeeeee",
                            fontWeight: "600",
                            color: "#757575",
                            ...item.style,
                          }
                    }
                  >
                    {item.title}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 &&
              data.map((item, i) => {
                const newStyle = rowClick ? { cursor: "pointer" } : {};
                const selectStyle =
                  rowSelect == item[selector] ||
                  checked?.findIndex((e) => e == item[checkbox]) > -1
                    ? { backgroundColor: darkMode ? "#6e5f28" : "#E8E9EB" }
                    : {};
                if (rowClick) {
                  return (
                    <tr
                      key={"key-" + i}
                      style={{
                        fontSize: "0.85rem",
                        fontWeight: "300",
                        ...selectStyle,
                        ...newStyle,
                      }}
                    >
                      {showIndex && (
                        <td className={`index-col`}>{i + startRow}</td>
                      )}
                      {checkbox && (
                        <td>
                          <input
                            type="checkbox"
                            disabled={
                              disabledCheckbox && item[disabledCheckbox]
                            }
                            checked={
                              checked?.findIndex((e) => e == item[checkbox]) >
                              -1
                            }
                            onChange={(e) =>
                              onSingleCheck(
                                item[checkbox],
                                item,
                                e.target.checked
                              )
                            }
                          />
                        </td>
                      )}
                      {columns.map((col, j) => {
                        if (col.clickable) {
                          return (
                            <td
                              key={"key_col" + j}
                              style={
                                col.style
                                  ? j == columns.length - 1
                                    ? {
                                        borderLeft: "1px solid #eeeeee",
                                        borderRight: "1px solid #eeeeee",
                                        ...col.style,
                                      }
                                    : { ...col.style }
                                  : j == columns.length - 1
                                  ? {
                                      borderLeft: "1px solid #eeeeee",
                                      borderRight: "1px solid #eee",
                                    }
                                  : {}
                              }
                              onClick={() => onRowClick(item)}
                            >
                              {col.render ? col.render(item) : item[col.field]}
                            </td>
                          );
                        } else {
                          return (
                            <td
                              key={"key_col" + j}
                              style={
                                col.style
                                  ? j == columns.length - 1
                                    ? {
                                        borderRight: "1px solid #eeeeee",
                                        ...col.style,
                                      }
                                    : { ...col.style }
                                  : j == columns.length - 1
                                  ? {
                                      borderRight: "1px solid #eeeeee",
                                    }
                                  : {}
                              }
                            >
                              {col.render ? col.render(item) : item[col.field]}
                            </td>
                          );
                        }
                      })}
                    </tr>
                  );
                } else {
                  return (
                    <tr
                      key={"key-" + i}
                      style={{
                        ...selectStyle,
                      }}
                    >
                      {showIndex && (
                        <td className="index-col">{i + startRow}</td>
                      )}
                      {columns.map((col, j) => {
                        return (
                          <td
                            key={"key_col" + j}
                            style={
                              col.style
                                ? j == columns.length - 1
                                  ? {
                                      borderRight: "1px solid #eeeeee",
                                      ...col.style,
                                    }
                                  : { ...col.style }
                                : j == columns.length - 1
                                ? {
                                    borderRight: "1px solid #eeeeee",
                                  }
                                : {}
                            }
                          >
                            {col.render ? col.render(item) : item[col.field]}
                          </td>
                        );
                      })}
                    </tr>
                  );
                }
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableData;
